import { AgGridService } from "@topline/services/agGridService";
import { IdSvrAuthService } from "../../../auth/idSrvAuthService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('marketBrand', {
        template: require('./marketBrandComponent.html'),
        controller: ['$scope', angularServicesNames.$translate, 'marketBrandService', AgGridService.componentName, 'AlertService', IdSvrAuthService.componentName,
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                marketBrandService: $TSFixMe,
                agGridService: AgGridService,
                AlertService: AlertService,
                authService: IdSvrAuthService
            ) {
                var $ctrl = this;

                authService.hasPermissionAsync('EditMarketBrand').then(result => $ctrl.canEdit = result);
                $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.actions = {};
                $ctrl.importInProgress = false;

                $ctrl.gridOptions = {
                    columnDefs: [{
                            headerValueGetter: () => $translate.instant("CONFIGURATION.MARKET_BRAND.BRAND"),
                            field: "name"
                        }
                    ],
                    domLayout: 'autoHeight',
                    angularCompileRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true
                    },
                    enableFilter: false,
                    animateRows: true,
                    pagination: true,
                    paginationPageSize: 15,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        loadData();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                };

                $ctrl.actions = {
                    import: function () {
                        $ctrl.importInProgress = true;
                        marketBrandService
                            .import()
                            .then((response: $TSFixMe) => {
                                if (response.status == HttpStatus.OK || response.status == 204) {
                                    AlertService.success($translate.instant("CONFIGURATION.MARKET_BRAND.IMPORT_COMPLETED"));
                                    $ctrl.importInProgress = false;
                                    loadData();
                                }
                        });
                    }
                }

                function loadData() {
                    marketBrandService.get().then((items: $TSFixMe) => {
                        $ctrl.gridApi.setRowData(items);
                    });
                }
            }
        ]
    });

}(angular.module('topline.modules')));